export default __webpack_public_path__ + "images/0615fbcc45dd88a4c75b3c1e2d35edcc-libfoundation.browser.wasm";